import { render, staticRenderFns } from "./news-list-entry.vue?vue&type=template&id=52f64c12"
import script from "./news-list-entry.vue?vue&type=script&lang=js"
export * from "./news-list-entry.vue?vue&type=script&lang=js"
import style0 from "./news-list-entry.vue?vue&type=style&index=0&id=52f64c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports